export const BEPI_API = Object.freeze({
  client: '/web/client',
  workshop: '/web/workshop',
  admin: '/web/admin',
  catalog: '/web/client/catalog/hierarchy',
});

